export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";